import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';
import offerConfig from './__config';

export const prerender = true;

const ROUTE_PATH = '/giveaway/family-vacation-2026';

/**
 * @returns {Promise<{ page: Page } | { metadata: import('$lib/utils/page').PageMetadata } | undefined>}
 */
export async function load() {
	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata: offerConfig.metadata,
			policies: { policy, policyExceptionHandler },
			routePath: ROUTE_PATH,
		});
		return { page };
	}

	return { metadata: offerConfig.metadata };
}
